import React, {useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
import 'leaflet/dist/leaflet.css'
import SectionTitle from "./SectionTitle";
import '../assets/css/sigmap.css';
import MultiLingualContent from '../config/multilingualContent';
import {LanguageContext} from "../config/multilingualContext";

const SigMap = () => {
      const { language, toggleLanguage } = useContext(LanguageContext);

    return (
        <div className="container about-list-items mb-5 sigmap-coming-soon">
            <SectionTitle pageTitle="sig"/>
            <div className="coming-soon-card">
                <div className="coming-soon-content">
                    <h3><MultiLingualContent contentID="sig_map_coming_soon" /></h3>
                    <p>
                        <MultiLingualContent contentID="sig_map_under_development" />
                    </p>
                </div>
            </div>
        </div>


    );
};

export default SigMap;